<template><div class="bash-box compare-box">
                <p class="h1-title">{{ indata.FirstTitle }}</p>
                <p class="h2-title">{{ indata.subTitle }}</p>
                <div class="bash-wrap compare-content-box">
                    <div class="compare-left-box">
                        <p class="title">{{ indata.title1 }}</p>
                        <ul class="compare-list-ul">
                            <li>{{ indata.produce1}}</li>
                        </ul>
                    </div>
                    <div class="compare-vs-box">
                        <p class="title">VS</p>
                        <i class="vs" :style="'background:url('+indata.bgcImage+') no-repeat 50% 50%'" ></i>
                    </div>
                    <div class="compare-left-box compare-right-box">
                        <p class="title">{{ indata.title2 }}</p>
                        <ul class="compare-list-ul">
                            <li>{{ indata.produce2 }}</li>
                        </ul>
                    </div>
                </div>
            </div>
</template>
<style scoped src="../../public/css/wmsBasis.css">
</style>



<script>
export default {
  name: "Templates23",
  props: {
    indata: Array,
  },
  computed: {
    //这里设置banner 是在900像素下高度为200px，我的banner图格式为1920X900像素
    autoHeight() {
      let _w =
        document.documentElement.clientWidth || document.body.clientWidth;
      return (_w * 200) / 450 + "px";
    },
    
  },
  data() {
    return {
      NowIndex: 0,
    };
  },
  methods: {
    changeActive(index) {
      this.NowIndex = index;
    },
  },
};
</script>

